import { ExperimentOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { useTranslation } from "react-i18next";

import { useResetDemo } from "../model/useResetDemo";

/**
 * Сброс демо-счёта пользователя. Под подтверждением, как и блокировка:
 * действие закрывает все демо-позиции разом, и случайное нажатие стоило бы
 * человеку всего, что он успел посмотреть.
 */
export function ResetDemoButton({ userId }: { userId: number }) {
  const { t } = useTranslation();
  const { modal, message } = App.useApp();
  const mutation = useResetDemo(userId);

  return (
    <Button
      icon={<ExperimentOutlined aria-hidden />}
      loading={mutation.isPending}
      onClick={() => {
        void modal.confirm({
          title: t("users.resetDemo"),
          content: t("users.resetDemoConfirm"),
          okText: t("users.resetDemo"),
          cancelText: t("common.cancel"),
          onOk: async () => {
            await mutation.mutateAsync();
            void message.success(t("users.resetDemoDone"));
          },
        });
      }}
    >
      {t("users.resetDemo")}
    </Button>
  );
}
